import React from 'react'
import {useStyles} from './styles'


//custom components
import GraphCard from './GraphCard'

//material ui 
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Typography from '@material-ui/core/Typography'

function OTDWeekAtual(){
    const classes = useStyles();
    return (
        <Card className={classes.root}>
        <CardContent>
        <Typography className={classes.title} color="textSecondary" gutterBottom>
        <b>OTD W Atual</b>
        </Typography>
        <GraphCard />
        </CardContent>
            <CardActions></CardActions>
        </Card>
    )
}


export default OTDWeekAtual;